import { type Ref, forwardRef } from "react";
import type { StepProps } from "./types";
import { cn } from "~/lib/utils";
import Img from "~/components/UI/Img";
import ShowcaseInlineCard from "~/components/ShowcaseInlineCard";

const Step = forwardRef(
  (
    { title, description, icon, img, className, index, theme, cta, cards }: StepProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        className={cn(
          "flex flex-col items-center justify-center gap-x-32 md:flex-row py-4 md:py-8",
          theme === "dark" && "dark",
          className,
        )}
        key={title}
        ref={ref}
      >
        <ShowcaseInlineCard
          title={title}
          description={description}
          icon={icon}
          beforeTitle={
            <p className="text-secondary">
              <strong>Step {index + 1}:</strong>
            </p>
          }
          cta={cta}
          cards={cards}
          theme={theme}          
        />
        
        <div>
          <Img
            src={img}
            alt={title}
            className="h-[25rem] w-[32rem] object-contain sc"
            style={{
              filter: "drop-shadow(0px 2px 16px hsla(var(--secondary) / 0.4))",
            }}
            width={600}
            height={400}
          />
        </div>
      </div>
    );
  },
);

Step.displayName = "Step";

export default Step;
